import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("erp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  login: (username, password) => api.post("/auth/login", { username, password }).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
  changePassword: (current_password, new_password) => api.post("/auth/change-password", { current_password, new_password }).then((r) => r.data),
};

export const usersApi = {
  list: () => api.get("/users").then((r) => r.data),
  modules: () => api.get("/users/modules").then((r) => r.data),
  create: (d) => api.post("/users", d).then((r) => r.data),
  update: (id, d) => api.put(`/users/${id}`, d).then((r) => r.data),
  remove: (id) => api.delete(`/users/${id}`).then((r) => r.data),
};

export const contactsApi = {
  list: (params) => api.get("/contacts", { params }).then((r) => r.data),
  create: (data) => api.post("/contacts", data).then((r) => r.data),
  update: (id, data) => api.put(`/contacts/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/contacts/${id}`).then((r) => r.data),
};

export const documentsApi = {
  list: (params) => api.get("/documents", { params }).then((r) => r.data),
  get: (id) => api.get(`/documents/${id}`).then((r) => r.data),
  create: (data) => api.post("/documents", data).then((r) => r.data),
  update: (id, data) => api.put(`/documents/${id}`, data).then((r) => r.data),
  setStatus: (id, status) => api.patch(`/documents/${id}/status`, { status }).then((r) => r.data),
  lastAccount: (contactId, group) => api.get(`/contacts/${contactId}/last-account`, { params: { group } }).then((r) => r.data),
  remove: (id) => api.delete(`/documents/${id}`).then((r) => r.data),
};

export const settingsApi = {
  get: () => api.get("/settings").then((r) => r.data),
  update: (data) => api.put("/settings", data).then((r) => r.data),
};

export const dashboardApi = {
  get: () => api.get("/dashboard").then((r) => r.data),
};

export const paymentsApi = {
  list: (docId) => api.get(`/documents/${docId}/payments`).then((r) => r.data),
  create: (docId, data) => api.post(`/documents/${docId}/payments`, data).then((r) => r.data),
  remove: (id) => api.delete(`/payments/${id}`).then((r) => r.data),
  statement: (contactId) => api.get(`/contacts/${contactId}/statement`).then((r) => r.data),
};

export const employeesApi = {
  list: (params) => api.get("/employees", { params }).then((r) => r.data),
  create: (data) => api.post("/employees", data).then((r) => r.data),
  update: (id, data) => api.put(`/employees/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/employees/${id}`).then((r) => r.data),
};

export const payrollApi = {
  settings: () => api.get("/payroll/settings").then((r) => r.data),
  saveSettings: (data) => api.put("/payroll/settings", data).then((r) => r.data),
  preview: (data) => api.post("/payroll/preview", data).then((r) => r.data),
  run: (data) => api.post("/payroll/run", data).then((r) => r.data),
  list: (params) => api.get("/payroll/payslips", { params }).then((r) => r.data),
  setStatus: (id, status) => api.patch(`/payroll/payslips/${id}/status`, { status }).then((r) => r.data),
  remove: (id) => api.delete(`/payroll/payslips/${id}`).then((r) => r.data),
  recalculate: (id) => api.post(`/payroll/payslips/${id}/recalculate`).then((r) => r.data),
};

export const PAY_KINDS = ["salary", "christmas", "easter", "leave"];
export const ABSENCE_TYPES = ["annual_leave", "sick", "unpaid", "overwork", "overtime"];
export const LEAVE_TYPES = ["annual_leave", "sick", "unpaid"];

export const mydataApi = {
  settings: () => api.get("/mydata/settings").then((r) => r.data),
  saveSettings: (data) => api.put("/mydata/settings", data).then((r) => r.data),
  overview: () => api.get("/mydata/overview").then((r) => r.data),
  testConnection: () => api.post("/mydata/test-connection").then((r) => r.data),
  send: (docId, invoice_type) => api.post(`/mydata/documents/${docId}/send`, { invoice_type }).then((r) => r.data),
  cancel: (docId) => api.post(`/mydata/documents/${docId}/cancel`).then((r) => r.data),
  classify: (docId, data) => api.post(`/mydata/documents/${docId}/classify`, data).then((r) => r.data),
  xmlUrl: (docId, type) => `${API}/mydata/documents/${docId}/xml?invoice_type=${type}`,
  logXmlUrl: (id) => `${API}/mydata/log/${id}/xml`,
  log: () => api.get("/mydata/log").then((r) => r.data),
  payroll: () => api.get("/mydata/payroll").then((r) => r.data),
  sendPayroll: (year, month) => api.post("/mydata/payroll/send", { year, month }).then((r) => r.data),
  incoming: (status) => api.get("/mydata/incoming", { params: { status } }).then((r) => r.data),
  syncIncoming: () => api.post("/mydata/incoming/sync").then((r) => r.data),
  unlinkedPurchases: () => api.get("/mydata/incoming/unlinked-purchases").then((r) => r.data),
  linkIncoming: (id, document_id) => api.post(`/mydata/incoming/${id}/link`, { document_id }).then((r) => r.data),
  createFromIncoming: (id) => api.post(`/mydata/incoming/${id}/create-document`).then((r) => r.data),
  classifyIncoming: (id, category) => api.post(`/mydata/incoming/${id}/classify`, { category }).then((r) => r.data),
};

export const apdApi = {
  summary: (year, month) => api.get("/payroll/apd/summary", { params: { year, month } }).then((r) => r.data),
  fileUrl: (year, month) => `${API}/payroll/apd?year=${year}&month=${month}`,
};

export const ledgerApi = {
  accounts: () => api.get("/ledger/accounts").then((r) => r.data),
  expenseAccounts: (kind = "expense") => api.get("/ledger/expense-accounts", { params: { kind } }).then((r) => r.data),
  createAccount: (d) => api.post("/ledger/accounts", d).then((r) => r.data),
  updateAccount: (code, d) => api.put(`/ledger/accounts/${code}`, d).then((r) => r.data),
  deleteAccount: (code) => api.delete(`/ledger/accounts/${code}`).then((r) => r.data),
  trialBalance: (params) => api.get("/ledger/trial-balance", { params }).then((r) => r.data),
  ledger: (code, params) => api.get(`/ledger/accounts/${code}/ledger`, { params }).then((r) => r.data),
  journal: (params) => api.get("/ledger/journal", { params }).then((r) => r.data),
  createEntry: (d) => api.post("/ledger/journal", d).then((r) => r.data),
  deleteEntry: (id) => api.delete(`/ledger/journal/${id}`).then((r) => r.data),
  exportUrl: (params) => `${API}/ledger/journal/export.xlsx?${new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([, v]) => v))).toString()}`,
};
export const registryApi = {
  settings: () => api.get("/aade/registry/settings").then((r) => r.data),
  saveSettings: (d) => api.put("/aade/registry/settings", d).then((r) => r.data),
  lookup: (afm) => api.post("/aade/registry/lookup", { afm }).then((r) => r.data),
};

export const ACCOUNT_TYPES = ["asset", "liability", "equity", "income", "expense"];

export const mydataError = (err, t) => {
  const detail = err?.response?.data?.detail;
  const key = `err_${detail}`;
  const msg = typeof detail === "string" ? t(key) : null;
  if (msg && msg !== key) return msg;
  if (typeof detail === "string" && detail.startsWith("RG_WS_PUBLIC_TOKEN_USERNAME_NOT_AUTHENTICATED")) return t("err_registry_bad_credentials");
  if (typeof detail === "string" && detail.trim()) return detail;
  return t("error");
};

export const absencesApi = {
  list: (params) => api.get("/absences", { params }).then((r) => r.data),
  create: (data) => api.post("/absences", data).then((r) => r.data),
  update: (id, data) => api.put(`/absences/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/absences/${id}`).then((r) => r.data),
  summary: (year) => api.get("/absences/summary", { params: { year } }).then((r) => r.data),
};
export const docBalance = (d) => (d.status === "cancelled" ? 0 : d.total - (d.paid_amount || 0));

export const DOC_TYPES = ["invoice", "service_invoice", "retail_receipt", "purchase", "purchase_service", "expense"];
export const SALE_TYPES = ["invoice", "service_invoice", "retail_receipt"];
export const BUY_TYPES = ["purchase", "purchase_service", "expense"];
export const FINANCIAL_TYPES = [...SALE_TYPES, ...BUY_TYPES];
export const DOC_GROUPS = { sales: SALE_TYPES, purchases: BUY_TYPES };
export const DOC_STATUSES = ["draft", "issued", "paid", "cancelled"];
export const VAT_RATES = [24, 13, 6, 0, 17, 9, 4];
export const PAYMENT_METHODS = ["bank", "cash", "card", "credit"];
